import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { SplitButton } from "primereact/splitbutton";
import { useLoadingContext } from "provider/LoadingProvider";
import PlanoAuditoriaService from "service/auditoria5s/PlanoAuditoriaService";
import { booleanFilterTemplate, filterApplyTemplate, IdMatchModeOptions, TextMatchModeOptions } from "utils/filterUtils";
import saveAs from 'file-saver';
import { useState } from "react";
import PlanoAuditoria from "model/auditoria5s/planoDeAuditoria/PlanoAuditoria";
import { Button } from "primereact/button";
import { useToastContext } from "components/alert/ToastContext";

const planoAuditoriaService = new PlanoAuditoriaService();

export default function PlanoAuditoriaListagem() {
    const { startLoading, stopLoading } = useLoadingContext();
    const [visibleDialogRelatorios, setVisibleDialogRelatorios] = useState(false);
    const [editaRelatorio, setEditaRelatorio] = useState(false);
    const { msgErro } = useToastContext();

    const defaultFilters: DataTableFilterMeta = {
        nome: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        ativo: {
            constraints: [
                {
                    value: true,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        }
    }

    const relatorioButton = (rowData: PlanoAuditoria) => {
        if (editaRelatorio) {
            return <SplitButton
                model={[{
                    label: "Alterar relatórios",
                    command: () => setVisibleDialogRelatorios(true)
                }]}
                icon="pi pi-file-pdf"
                onClick={() => {
                    gerarRelatorio(rowData);
                }}
            ></SplitButton>
        }
        return <Button icon="pi pi-file-pdf"
            onClick={() => {
                gerarRelatorio(rowData);
            }}
        ></Button>
    }

    const gerarRelatorio = (rowData: PlanoAuditoria) => {
        startLoading();
        planoAuditoriaService.getRelatorio(rowData.id).then(data => {
            const file = new Blob([data], { type: 'application/pdf' });
            saveAs(file, `${rowData.nome}.pdf`);
            stopLoading();
        }).catch(err => {
            stopLoading();
            msgErro("Erro ao gerar Relatório", err.message);
            console.log(err);
        });
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={planoAuditoriaService} defaultFilters={defaultFilters} urlService="/planoAuditoria" tituloPagina={'Planos de Auditoria'} showClearFilterButton nome="planoAuditoria">
            <Column field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="ativo" header="Ativo" body={(rowData) => rowData.ativo ? 'Sim' : 'Não'}
                filter filterPlaceholder="Qualquer" showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate} filterElement={(options) => booleanFilterTemplate(options)} />
            <Column style={{width: 65}} body={(rowData) => relatorioButton(rowData)} />
        </BaseListagem>
    )
}
